import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  atomDossier,
  atomEvaluatePremium,
  atomFormikGroup,
  defaultValueContractorLegal,
} from "src/storage";
import {
  ContractorType,
  FileUploadedStatus,
  Formik,
  FormikInsurance,
} from "src/types";
import { useScrollToError } from "../handlers/scroll-to-error.hook";
import { useValidateInsured } from "../handlers/validation-schemas.hook";
import {
  toEvaluatePremiumRequest,
  usePostEvaluatePremium,
} from "src/networking/terminals";

export const useDataEntryGroup = ({
  insuranceFormik,
}: {
  insuranceFormik: Formik<FormikInsurance>;
}) => {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(true);
  const [formikGroup, saveFormikGroup] = useRecoilState(atomFormikGroup);
  const { values } = insuranceFormik;

  const { triggerFormikCheck } = useScrollToError(insuranceFormik);
  const insuredValidationSchema = useValidateInsured();

  useEffect(() => {
    insuranceFormik.setFieldValue("contractorType", ContractorType.LEGAL);
    insuranceFormik.setFieldValue("contractor", defaultValueContractorLegal);
  }, []);

  useEffect(() => {
    if (!formikGroup.group || formikGroup.group?.length === 0) {
      setIsDisabled(true);
      return;
    }

    const hasErrors = formikGroup.filesStatus !== FileUploadedStatus.OK;

    setIsDisabled(hasErrors);
  }, [formikGroup.group]);

  // Evaluate Premium ===============================================
  const dossier = useRecoilValue(atomDossier);
  const {
    crossGate: postEvaluatePremium,
    pending: postEvaluatePremiumPending,
  } = usePostEvaluatePremium();
  const [evaluatedPremium, saveEvaluatePremium] =
    useRecoilState(atomEvaluatePremium);
  const evaluatePremium = () => {
    doPostEvaluatePremium();
  };
  const doPostEvaluatePremium = () => {
    const body_ = toEvaluatePremiumRequest(values);
    if (body_) {
      postEvaluatePremium(
        {
          headers: {
            xDossierId: dossier?.dossierId || "",
          },
          body: body_,
        },
        {
          onSuccess: saveEvaluatePremium,
        }
      );
    }
  };

  return {
    isDisabled,
    insuredValidationSchema,
    evaluatedPremium,
    postEvaluatePremiumPending,
    t,
    evaluatePremium,
    triggerFormikCheck,
  };
};
